<template>
  <div id="inicio" class="user-start">
    <!-- INICIO SIN ONBOARDING -->
    <template>

      <compliance-banner class="mb-6 text-align-left" :showBanner="!SessionLocationRegistered" />

      <div v-if="supplierObject.restriction_level != 'no_restriction'" class="vx-row mb-2">
        <div class="vx-col w-full">
          <SupplierRestrictedDataNotification :source="supplierObject" />
        </div>
      </div>

      <div v-if="!hasFinished" class="mb-5">
        <div class="vx-row justify-between">
          <div class="vx-col w-full mb-2">
            <vs-alert color="warning" active="true" style="height:auto">
              Tu perfil esta en <strong>proceso de verificación</strong>. Puedes crear una Pre-Solicitud para que
              RedGirasol evalúe su viabilidad crediticia. Solo considera que para concluir el proceso de evaluación de
              la Solicitud deberás tener tu perfil como Proveedor ya verificado por parte de RedGirasol.
              <br>
              Si tienes alguna duda, por favor comunícate al número <strong>{{ phoneFormat("8115398784") }}</strong> y
              manda un mensaje de Whatsapp al mismo número.
              <br>
              <vs-button class="mt-2 mb-2" color="warning" @click.stop="goTo('SupplierOnboardingHomePage')">Completar
                perfil</vs-button>
              <vs-button @click.stop="goToHome()" color="primary" class="mr-3 ml-3">Envíar WhatsApp</vs-button>
              <vs-button @click.stop="goToCall()" color="dark" class="">Llamar al {{ phoneFormat("8115398784")
                }}</vs-button>
            </vs-alert>
          </div>
        </div>
      </div>

      <!-- SOLICITUDES DE CRÉDITO ASIGNADAS -->
      <!-- <div>
        <NewAssignedLoansRequest />
      </div> -->

      <!-- cards -->
      <div class="vx-row same-h">
        <div class="vx-col sm:w-full sm:w-1/2 md:w-7/12 lg:w-7/12 mb-base">
          <vx-card class="gradient-border">
            <h1 class="mb-base white w-2/3 mt-24">
              Crédito Solar <br>para tus clientes
            </h1>
            <vs-button @click.stop="$router.push('/proveedor/simulador-express?credit-type=5')" size="small"
              class="primary mr-3 mb-base text-white sm:w-1/2 md:w-1/4" type="border">Simular</vs-button>
            <vs-button @click.stop="$router.push('/proveedor/crear-proyecto/nuevo')" size="small"
              class="primary mb-base sm:w-1/2 md:w-1/4">Solicitar</vs-button>
            <p class="text-white mb-0 text-sm flex">
              <span @click.stop="canCreateLoanRequests ? downloadQRCode() : showNotification()"
                class="flex clickable-img mr-4">
                <feather-icon icon="DownloadIcon"
                  class="mr-2 h-5 w-5 cursor-pointer text-white rounded-full"></feather-icon>
                <u>Descargar código QR para que tu cliente cree su solicitud.</u>
              </span>
              <span @click.stop="canCreateLoanRequests ? myFunction() : showNotification()" class="flex clickable-img">
                <feather-icon icon="CopyIcon"
                  class="mr-2 h-5 w-5 cursor-pointer text-white rounded-full"></feather-icon>
                <u>Copiar mi enlace.</u>
              </span>
            </p>
          </vx-card>
        </div>
        <div class="vx-col sm:w-full sm:w-1/2 md:w-5/12 lg:w-5/12 mb-base">
          <vx-card class="second-card">
            <h1 class="mb-base white w-2/3 mt-12">
              Crédito <br>
              PyME <br>
              para ti
            </h1>
            <vs-button @click.stop="$router.push('/proveedor/simulador-express?credit-type=6')" size="small"
              class="primary mr-3 mb-base text-white sm:w-1/2 md:w-1/3" type="border">Simular</vs-button>
            <vs-button @click.stop="isLeadFormActive = true" size="small"
              class="primary mb-base sm:w-1/2 md:w-1/3">Solicitar</vs-button>
          </vx-card>
        </div>
      </div>

      <!-- VERIFICACIÓN DE CUENTAS -->
      <SupplierBankAccountNotif />

      <!-- verificación de identidad -->
      <div v-if="showIdentityVerification" class="vx-row">
        <div class="vx-col sm:w-full md:w-2/3 mb-base">
          <vx-card title="Verificación de identidad" class="card-txt special-card">
            <div class="vx-row m-2">
              <supplier-identity-verification ref="supplier_identity_verification" :isMoral="isMoral" :userId="UserId"
                :personType="UserPersonType" :supplierId="SupplierId" />
            </div>
          </vx-card>
        </div>
      </div>

      <!-- RESUMEN DE PROYECTOS -->
      <div v-if="SupplierOrAgentHasAtLeastOneProject" class="vx-row">
        <div class="vx-col w-full h-auto">
          <projects-summary-widget />
        </div>
      </div>

      <!-- REPORTE DE AVANCE DEL PROGRAMA -->
      <div v-if="isProgramSupplier" class="mb-6">
        <progress-report-widget></progress-report-widget>
      </div>

      <!-- FORM LEAD -->
      <vs-popup class="feedback-popup" title="Crédito PyME para tu negocio" :active.sync="isLeadFormActive" :width="600"
        :scrollable="true">
        <template>
          <div class="p-4">
            <p class="mb-4 text-sm black">Aprovecha las oportunidades que tiene tu negocio con el Crédito PyME para instaladores.</p>
            <p class="bold black mt-base">¿Cuánto necesitas?</p>
            <vs-input 
              v-money="money"
              v-model="productValue"
              icon="icon-dollar-sign"
              icon-pack="feather"
              placeholder="Ingresa un monto"
              class="mt-4 w-2/3 mb-base" />

            <div>
              <p class="bold black mt-base mb-4">¿A qué plazo deseas pagar tu crédito?</p>
              <div class="vx-row mb-base">
                  <div class="vx-col sm:w-1/3 md:w-1/4 lg:w-1/5"
                      v-for="(item, index) in currentTerm" :key="index">
                      <rg-radio
                          class="w-full" groupName="termsOptions" :label="`${item} meses`"
                          :value="item" v-model="loanTerm" />
                  </div>
              </div>
            </div>
            <vs-button @click.stop="createSupplierLead()" size="lg" class="mt-4 sm:w-1/2 md:w-1/3 lg:w-1/4">Enviar</vs-button>
          </div>
        </template>
      </vs-popup>
    </template>
    <!-- INICIO SIN ONBOARDING -->
  </div>
</template>

<script>
import ProgressReportWidget from '../../components/supplier/widgets/ProgressReportWidget.vue';
import * as moment from "moment";
//  Registered Widgets
import '@/widgets.js'
import SupplierOnboardingHomePage from './onboarding/SupplierOnboardingHomePage.vue';
import SupplierIdentityVerification from '../../components/supplier/profile/SupplierIdentityVerification.vue';
import userIdentityHelper from "@/helpers/userIdentityHelper";
import formatHelper from "@mixins/formatHelper.js";
import NewAssignedLoansRequest from '../../components/supplier/widgets/NewAssignedLoansRequest.vue';
import SupplierRestrictedDataNotification from '@/views/supplier/homes/SupplierRestrictionLevelNotif.vue';
import SupplierBankAccountNotif from '@/views/supplier/homes/SupplierBankAccountNotif.vue';
import ComplianceBanner from '@components/compliance/ComplianceBanner';
import {VMoney} from 'v-money';

const lastStepPM = "pm_mex_20_merchant_contract";
const lastStepPF = "pf_mex_18_merchant_contract";

export default {
  mixins: [userIdentityHelper, formatHelper],
  directives: {money: VMoney},
  components: {
    ProgressReportWidget,
    SupplierOnboardingHomePage,
    SupplierIdentityVerification,
    NewAssignedLoansRequest,
    SupplierRestrictedDataNotification,
    ComplianceBanner,
    SupplierBankAccountNotif
  },
  data() {
    return {
      showIdentityVerification: false,
      isLeadFormActive: false,
      productValue: null,
      money: {
          decimal: '.',
          thousands: ',',
          prefix: '',
          suffix: '',
          precision: 0,
          masked: false
      },
      currentTerm: [12, 24, 36, 48],
      loanTerm: null
    }
  },
  async beforeMount() {
    if (!this.hasFinished && this.isAgent) {
      await this.$router.replace({ name: 'supplierAgentOnboarding' });
    }

    if (this.ShowSupplierOnboarding) {
      if (this.isAgent) {
        await this.$router.replace({ name: 'supplierAgentOnboarding' });
      } else {
        await this.$router.replace({ name: 'supplierOnboarding' });
      }
    }
  },
  async mounted() {
    const data = await this.getUserIdentityStatus(this.UserId);
    if (data == null || data == 4 || data == 5 || data == 0) {
      this.showIdentityVerification = true;
    }
  },
  computed: {
    isAgent() {
      return this.$acl.check('isAgent');
    },
    hasFinished() {
      return (this.SupplierOnboardingStep == lastStepPM || this.SupplierOnboardingStep == lastStepPF) && this.SupplierVerifiedDate != null
    },
    getLogoUrl: function () {
      return this.$data.StorageURL + "/green/LOGOS/redgirasol.png"
    },
    isProgramSupplier() {
      return this.SupplierOrAgentProgramAccess;
    },
    isMoral() {
      return this.UserPersonType == 0;
    },
    supplierObject() {
      return {
        id: this.SupplierId,
        restriction_level: this.SupplierRestrictionLevel
      }
    },
    message() {
      return `Solicita tu Crédito Solar en RedGirasol *obtén financiamiento para tus paneles solares* para tu casa o negocio. Aprovecha la energía del sol y *ahorra hasta 95% de tu recibo de luz*.

Empieza tu registro aquí: ${this.supplierReferredUrl}`;
    },
    supplierReferredUrl() {
      return `${this.AppDomain}/registro/solicitante?r=${this.SupplierReferralCode}`;
    },
    isSupplierRestricted() {
      return this.supplierObject.restriction_level != 'no_restriction'
    },
    canCreateLoanRequests() {
      return !this.isSupplierRestricted && this.SessionLocationRegistered;
    }
  },
  methods: {
    showFeedback() {
      this.$store.commit('TOGGLE_IS_FEEDBACK_POPUP_ACTIVE', true)
    },
    async goTo(route) {
      await this.$router.replace({ name: route });
    },
    skip() {
      //this.setTourStatus(1,1);
    },
    finish() {
      //this.setTourStatus(2,1);
    },
    async goToHome() {
      window.open("https://wa.me/528115398784/?text=¡Hola, he terminado con el proceso para la apertura de mi cuenta!", "_blank")
    },
    async goToCall() {
      window.open("tel:8115398784")
    },
    async downloadQRCode() {
      try {
        const url = `${this.ApiDomain}/api/loan/get/${this.SupplierId}/qr-code-pdf-preview?access_token=${this.AccessToken}`;
        window.open(url, "_blank");
      } catch (error) {
        console.log(error);
      }
    },
    myFunction() {
      // Copy the text inside the text field
      navigator.clipboard.writeText(this.message);

      this.saveSuccessNotif(null, "Texto copiado correctamente.");
    },
    showNotification() {
      let message = "No puedes realizar esta acción por el momento."

      if (!this.SessionLocationRegistered) {
        message = "Permite el acceso a tu ubicación mientras usas la plataforma para poder disfrutar de todas sus funciones.";
      }
      this.$vs.dialog({
        type: 'alert',
        color: 'success',
        title: "Esta función está deshabilitada",
        text: message,
        acceptText: "Aceptar",
      });
    },
    async createSupplierLead() {
      try {
        if(this.loanTerm != null && this.productValue != null) {
          this.showLoading(true, "Enviando solicitud...");
          const response = await axios.post(`/api/v2/leads/registerSupplierFromApp`, {
            supplier_id: this.SupplierId,
            amount: this.productValue,
            term: this.loanTerm
          });

          this.saveSuccessNotif(null, "Tu solicitud ha sido enviada correctamente. Nos pondremos en contacto contigo.");
          this.isLeadFormActive = false;
          this.showLoading(false);
        } else {
          this.missingFieldsNotif();
          this.showLoading(false);
        }
      } catch (error) {
        this.showLoading(false);
      }
    }
  }
}
</script>
<style>
#preFooter {
  margin-bottom: -30px;
}

#feedbackAlert {
  margin-left: 1rem !important;
  margin-right: 1rem !important;
  cursor: pointer;
  height: auto !important;
}

.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, .4);
}

.v-step {
  z-index: 100000 !important;
  background: #3b3a3e !important;
}

.v-step .v-step__header {
  background: #3b3a3e !important;
}

.big-title-bg {
  background-color: #28DE18 !important;
}

.big-title-bg h1 {
  color: #fff !important;
  font-size: 3rem !important;
}

.big-title-bg h1 span {
  color: #3b3a3e !important;
  font-size: 3rem !important;
}

.user-start .vx-row .vx-col:not(.h-auto) {
  min-height: 30px !important;
}

.user-start .vx-row .vx-col:not(.h-auto) {
  margin-bottom: 0rem;
}

.vx-card .vx-card__collapsible-content .vx-card__body {
  padding: 1rem !important;
}

.xmas-header {
  background-color: #2d2d2d;
  color: #fff;
  padding: 2rem;
}

.xmas-header p {
  font-size: 2.1rem;
  line-height: 2.2rem;
}

.xmas-header p>span {
  color: #28DE18;
}

.xmas-header img {
  margin-bottom: 1rem;
  width: 50%;
}

#notification .vs-popup--header {
  background: #28DE18 !important;
}

#notification .vs-popup--header .vs-popup--title h3 {
  color: #fff !important;
}

.gradient-border {
  position: relative;
  padding: 10px 20px;
  background: #fff;
  /* margin: 5px; */
  border-radius: 5px;
  background-image: url("https://cdn.redgirasol.com/suppliers/resources/mkt-credito-solar.png");
  background-repeat: no-repeat;
  /* para que no se repita */
  background-size: cover;
  /* para que cubra toda la pantalla */
  background-position: top;
  /* centrada */

  /* border-image: linear-gradient(45deg, rgba(203,255,0,1) 0%, rgba(40,222,24,1) 100%) 1 !important; */
}

.gradient-border::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;

  margin: -3px;
  border-radius: inherit;
  /* background-image:linear-gradient(45deg, rgba(203,255,0,1) 0%, rgba(40,222,24,1) 100%); */
}

.special-card {
  border: 2px solid transparent !important;
  /* border: 1.5px solid #28de18; */
}

.special-card:hover {
  border-image: linear-gradient(45deg, rgba(203, 255, 0, 1) 0%, rgba(40, 222, 24, 1) 100%) 1 !important;
}

/* .first-card {
  padding: 3rem 3.5rem 2rem 3.5rem;
} */

.second-card {
  text-align: left;
  padding: 10px 20px;
  /* padding: 3rem 0.5rem 2rem 0.5rem; */
  background-image: url("https://cdn.redgirasol.com/suppliers/resources/mkt-credito-pyme.png");
  background-repeat: no-repeat;
  /* para que no se repita */
  background-size: cover;
  /* para que cubra toda la pantalla */
  background-position: top;
  /* centrada */
}

.card-txt {
  font-size: 18px;
  color: #3b3a3e;
}

.extrabold {
  font-size: 3rem;
}

span.primary {
  color: #28DE18 !important;
}

.overlay-disabled {
  background-color: #ffffffd1;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1;
  backdrop-filter: blur(2px);
}


.vs-popup--header {
    background-color: #28DE18;
    color: #fff !important;
}
    .vs-popup--header .vs-popup--title h3 {
        color: #fff !important;
    }

</style>
